// src/pages/TestGoogleAddressSearch.jsx
import React, { useState } from 'react';
import AddressSearchInput from '../components/AddressSearch-Google';
import './TestPages.css'; // Import the common styling

const TestGoogleAddressSearch = () => {
  const [selectedLocationData, setSelectedLocationData] = useState(null);

  // Handler for when a location is selected from the search component
  const handleLocationSelected = (geojson) => {
    console.log('Location selected in Test Page (Google):', geojson);
    setSelectedLocationData(geojson);
  };

  return (
    <div className="test-page-container">
      <h1>Test Address Search Input (Google Places)</h1>
      <p>This component uses the Google Places Autocomplete API to search for addresses.</p>

      <div className="test-component-area">
        <AddressSearchInput onLocationSelect={handleLocationSelected} placeholder="Search Google for an address..." />
      </div>

      {selectedLocationData && (
        <div className="test-results-area">
          <h2>Selected Location Data (GeoJSON):</h2>
          <pre>{JSON.stringify(selectedLocationData, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default TestGoogleAddressSearch;
